import React from 'react';
import SectionTasks from './SectionTasks';
import CompletedTasks from './CompletedTasks';
import NoOutstandingTasks from './NoOutstandingTasks';
import { Task } from './api';
import { TaskReport } from './utils';
import { User } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { AllocationReportCreationProps } from './Allocation/AllocationReportCreation';

type SectionTasksProps = React.ComponentProps<typeof SectionTasks>;

interface TodoTasksProps {
  debug: boolean;
  taskReports: TaskReport;
  userAttributes: User | undefined;
  noOutstandingTasks: boolean;
  tasks: {
    finalUpdateTasks: Task[];
    interimUpdateTasks: Task[];
    reportTasks: Task[];
    overdue: Task[];
    completed: Task[];
    incomplete: Task[];
    thisWeek: Task[];
    thisMonth: Task[];
    nextMonth: Task[];
    unallocatedInvestmentTasks: Task[];
  };
  allReports: AllocationReportCreationProps['allReports'];
  allPrograms: SectionTasksProps['allPrograms'];
  allNPOUsers: SectionTasksProps['allNPOUsers'];
  reloadTasks: () => void;
  reloadPrograms: SectionTasksProps['reloadPrograms'];
  reloadNPOUser: () => void;
}

const TodoTasks: React.FC<TodoTasksProps> = ({
  debug,
  taskReports,
  userAttributes,
  noOutstandingTasks,
  tasks,
  allReports,
  allPrograms,
  allNPOUsers,
  reloadTasks,
  reloadPrograms,
  reloadNPOUser,
}) => {
  return (
    <>
      {noOutstandingTasks && <NoOutstandingTasks />}
      <SectionTasks
        isDebug={debug}
        taskType="feedback"
        buttonText="Resolve"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Reports Feedback"
        tasks={tasks.reportTasks}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="others"
        buttonText="Allocate"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Allocate Donations"
        tasks={tasks.unallocatedInvestmentTasks}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="finalUpdate"
        buttonText="Finalize"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Final Updates Needed"
        tasks={tasks.finalUpdateTasks}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="interimUpdate"
        buttonText="Update"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Interim Updates Needed"
        tasks={tasks.interimUpdateTasks}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="others"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Due This Week"
        tasks={tasks.thisWeek}
        showFirstSelected={true}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="others"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Due This Month"
        tasks={tasks.thisMonth}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="others"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Due Next Month"
        tasks={tasks.nextMonth}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <SectionTasks
        isDebug={debug}
        taskType="others"
        taskReport={taskReports}
        currentUser={userAttributes}
        sectionName="Due Later"
        tasks={tasks.incomplete}
        showFirstSelected={false}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
      <CompletedTasks
        isDebug={debug}
        taskType="others"
        taskReport={taskReports}
        currentUser={userAttributes}
        completedTasks={tasks.completed}
        allReports={allReports}
        allPrograms={allPrograms}
        allNPOUsers={allNPOUsers}
        reloadTasks={reloadTasks}
        reloadPrograms={reloadPrograms}
        reloadNPOUser={reloadNPOUser}
      />
    </>
  );
};

export default TodoTasks;
